// extracted by mini-css-extract-plugin
module.exports = {"new":"Footer_new__2Hopg","rights_reserved":"Footer_rights_reserved__N7fsj","footer":"Footer_footer__1w0lV","allrightsText":"Footer_allrightsText__3uB3T"};